import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class ReportService {
  static downloadReport(id) {
    return HttpUtil.getFileData(API_ROUTES.REPORT.DOWNLOAD.replace('<regId>', id));
  }

  static listReportsGRI(
    pageNumber = 0,
    pageSize = 10,
    regulationId = "",
    companyId = "",
    status = ''
  ) {
    return HttpUtil.getFromReportingService(
      API_ROUTES.REPORT.LIST_REPORTS
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(regulationId ? "<regulationId>" : "&regulationId=<regulationId>", regulationId)
        .replace(companyId ? "<companyId>" : "&companyId=<companyId>", companyId)
        .replace(status >= 0 ? "<status>" : "&status=<status>", status >= 0 ? status : '')
    );
  }

  static createReport(payload) {
    payload.reportType = 'GRI';
    return HttpUtil.postForReportingService(API_ROUTES.REPORT.CREATE_REPORT, payload);
  }


  static updateReport(reportId, payload) {
    return HttpUtil.putForReportingService(API_ROUTES.REPORT.UPDATE_REPORT.replace("<reportId>", reportId), payload);
  }

  static getReport(reportId) {
    return HttpUtil.getFromReportingService(API_ROUTES.REPORT.GET_REPORT.replace("<reportId>", reportId), {});
  }

  static generatePDF(id) {
    return HttpUtil.getPDFData(API_ROUTES.REPORT.GENERATE_PDF.replace('<reportId>', id));
  }

  static reorderPage(reportId, pageId, payload) {
    return HttpUtil.patch(
      API_ROUTES.REPORT.REORDER_PAGE
        .replace("<reportId>", reportId)
        .replace("<pageId>", pageId)
      , payload
    );
  }

  static pollReportJOB() {
    return HttpUtil.getFromReportingService(API_ROUTES.REPORT.REPORT_JOB_POLL);
  }

  static updateReportContent(payload) {
    return HttpUtil.postForReportingService(API_ROUTES.REPORT.UPDATE_REPORT_CONTENT, payload);
  }

  static updateReportStatus(reportId, status) {
    return HttpUtil.patchForReportingService(
      API_ROUTES.REPORT.UPDATE_REPORT_STATUS
        .replace("<id>", reportId)
        .replace('<status>', status),
      {}
    );
  }

  static getESGOverviewPageData(standardId, period, sectionType,
    periodStart = '', periodEnd = '', buIds = []) {
    return HttpUtil.get(
      API_ROUTES.REPORT.GET_ESG_OVERVIEW_DATA
        .replace("<standardId>", standardId)
        .replace("<sectionType>", sectionType)
        .replace(periodStart && periodEnd ? "<periodStart>" : "?periodStart=<periodStart>", periodStart)
        .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
        .replace(
          buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
          buIds?.length > 0 ? buIds?.toString() : ''
        ),
      {}
    );
  }

  static updateJobStatus(jobId, status) {
    return HttpUtil.patchForReportingService(API_ROUTES.REPORT.UPDATE_REPORT_JOB_STATUS
      .replace('<id>', jobId)
      .replace('<status>', status));
  }

  static finalizeReport(id) {
    return HttpUtil.patchForReportingService(API_ROUTES.REPORT.FINALIZE
      .replace('<id>', id));
  }

  static uploadImage(formData) {
    return HttpUtil.postForReportingService(
      API_ROUTES.REPORT.UPLOAD_IMAGE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static listImages(key = null) {
    return HttpUtil.getFromReportingService(API_ROUTES.REPORT.LIST_IMAGES
      .replace(key ? '<key>' : '?key=<key>', key ?? ''));
  }

  static getImage(ref) {
    return API_ROUTES.REPORT.GET_IMAGE.replace('<ref>', ref);
  }

  static getMetricsForESGHighlights(standardId, period) {
    return HttpUtil.get(
      API_ROUTES.REPORT.GET_ESG_HIGHLIGHTS_METRICS
        .replace("<standardId>", standardId)
        .replace("<period>", period)
    );
  }

  static getReportTemplate({ pageId, type, standardId, period }) {
    return HttpUtil.get(API_ROUTES.REPORT.GET_TEMPLATE
      .replace(pageId ? '<pageId>' : '?page=<pageId>', pageId ?? '')
      .replace(type ? '<type>' : '&type=<type>', type ?? '')
      .replace(standardId ? '<standardId>' : '&standardId=<standardId>', standardId ?? '')
      .replace(period ? '<period>' : '&period=<period>', period ?? '')
    );
  }

  static captureReport(payload) {
    return HttpUtil.post(API_ROUTES.REPORT.CAPTURE_REPORT, payload);
  }

  static listGroupedStudioReports(
    type,
    pageNumber = 0,
    pageSize = 10,
    sort = "",
  ) {
    return HttpUtil.get(
      API_ROUTES.REPORT.LIST_GROUPED_STUDIO_REPORTS
        .replace("<type>", type)
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(sort ? "<sort>" : "&sort=<sort>", sort ?? '')
    );
  }

  static getReportTemplateData({ pageId, standardId, period, title, type }) {
    return HttpUtil.get(
      API_ROUTES.REPORT.GET_REPORT_TEMPLATE_DATA
        .replace("<pageId>", pageId)
        .replace("<type>", type)
        .replace("<standardId>", standardId)
        .replace("<period>", period)
        .replace("<title>", title)
    );
  }

  static getESGHighlightsData(standardId, period, periodStart = '', periodEnd = '', buIds = []) {
    return HttpUtil.get(
      API_ROUTES.REPORT.GET_ESG_HIGHLIGHTS_DATA
        .replace("<standardId>", standardId)
        .replace("<period>", period)
        .replace(periodStart && periodEnd ? "<periodStart>" : "?periodStart=<periodStart>", periodStart)
        .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
        .replace(
          buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
          buIds?.length > 0 ? buIds?.toString() : ''
        )
    );
  }

  static deleteImage(imageId) {
    return HttpUtil.deleteForReportingService(API_ROUTES.REPORT.DELETE_IMAGE.replace('<id>', imageId));
  }

  static getDataCompletionProgress(standardId, period, recentChangeInfo = false, periodStart = '', periodEnd = '', buIds = []) {
    return HttpUtil.get(
      API_ROUTES.REPORT.GET_INBOUND_PROGRESS
        .replace("<standardId>", standardId)
        .replace("<period>", period)
        .replace('<recentChangeInfo>', recentChangeInfo)
        .replace(periodStart && periodEnd ? "<periodStart>" : "&periodStart=<periodStart>", periodStart)
        .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
        .replace(
          buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
          buIds?.length > 0 ? buIds?.toString() : ''
        )
    );
  }

  static getDataCollectionProgress(standardId, period, periodStart = '', periodEnd = '', options = {}) {
    let url = API_ROUTES.REPORT.GET_DATA_COLLECTION_PROGRESS
      .replace("<standardId>", standardId)
      .replace("<period>", period)
      .replace(periodStart && periodEnd ? "<periodStart>" : "&periodStart=<periodStart>", periodStart)
      .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd);

    const queryParts = [];
    if (options.forParentBranches !== undefined) {
      queryParts.push(`forParentBranches=${options.forParentBranches}`);
    }
    if (options.parentBranchId) {
      queryParts.push(`parentBranchId=${options.parentBranchId}`);
    }
    if (queryParts.length) {
      url += `&${queryParts.join('&')}`;
    }

    return HttpUtil.get(url);
  }

  static createCoDraftJob(id) {
    return HttpUtil.postForReportingService(API_ROUTES.REPORT.CREATE_CODRAFT_JOB.replace('<id>', id), {});
  }

  static createESRSReport(payload) {
    return HttpUtil.postForReportingService(API_ROUTES.ESRSREPORT.CREATE_REPORT, payload);
  }

  static createGHGReport(payload) {
    return HttpUtil.postForReportingService(API_ROUTES.GHGREPORT.CREATE_GHG_REPORT, payload);
  }

  static createBRSRReport(payload) {
    return HttpUtil.postForReportingService(API_ROUTES.BRSRREPORT.CREATE_BRSR_REPORT, payload);
  }

  static listReports(
    pageNumber = 0,
    pageSize = 10,
    regulationId = "",
    companyId = "",
    status = '',
    type = '',
    year = '',
    reportType = ''
  ) {
    return HttpUtil.getFromReportingService(
      API_ROUTES.ESRSREPORT.LIST_REPORTS
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(regulationId ? "<regulationId>" : "&regulationId=<regulationId>", regulationId)
        .replace(companyId ? "<companyId>" : "&companyId=<companyId>", companyId)
        .replace(status >= 0 ? "<status>" : "&status=<status>", status >= 0 ? status : '')
        .replace(type ? "<type>" : "&type=<type>", type)
        .replace(year ? "<year>" : "&year=<year>", year)
        .replace(reportType ? "<reportType>" : "&reportType=<reportType>", reportType)
    );
  }

  static getESRSReport(reportId) {
    return HttpUtil.getFromReportingService(API_ROUTES.ESRSREPORT.GET_REPORT.replace("<reportId>", reportId), {});
  }

  static getGHGReport(reportId) {
    return HttpUtil.getFromReportingService(API_ROUTES.GHGREPORT.GET_REPORT.replace("<reportId>", reportId), {});
  }

  static getBRSRReport(reportId) {
    return HttpUtil.getFromReportingService(API_ROUTES.BRSRREPORT.GET_REPORT.replace("<reportId>", reportId), {});
  }

  static generateBRSRXBRL(payload) {
    return HttpUtil.postForBRSRXbrl(API_ROUTES.REPORT_AI.BRSR_XBRL_GENERATE, payload);
  }

  static updateESRSReport(reportId, payload) {
    return HttpUtil.putForReportingService(API_ROUTES.ESRSREPORT.UPDATE_REPORT.replace("<reportId>", reportId), payload);
  }

  static updateGHGReport(reportId, payload) {
    return HttpUtil.putForReportingService(API_ROUTES.GHGREPORT.UPDATE_GHG_REPORT.replace("<reportId>", reportId), payload);
  }

  static updateBRSRReport(reportId, payload) {
    return HttpUtil.putForReportingService(API_ROUTES.BRSRREPORT.UPDATE_BRSR_REPORT.replace("<reportId>", reportId), payload);
  }

  static generateESRSPDF(id) {
    return HttpUtil.getReportingPDFData(API_ROUTES.ESRSREPORT.GENERATE_PDF.replace('<reportId>', id));
  }
  static getReportV2Template({ pageId, type, standardId, period, answerCheck = false, periodEnd = '', buIds = [], rFreq = null }) {
    return HttpUtil.get(API_ROUTES.ESRSREPORT.GET_TEMPLATE
      .replace(pageId ? '<pageId>' : '?page=<pageId>', pageId ?? '')
      .replace(type ? '<type>' : '&type=<type>', type ?? '')
      .replace(standardId ? '<standardId>' : '&standardId=<standardId>', standardId ?? '')
      .replace(period ? '<period>' : '&period=<period>', period ?? '')
      .replace('<answerCheck>', answerCheck)
      .replace("<periodEnd>", periodEnd)
      .replace(
        buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
        buIds?.length > 0 ? buIds?.toString() : ''
      )
      .replace(rFreq ? "<rFreq>" : "&rFreq=<rFreq>", rFreq ? rFreq : '')
    );
  }

  static finalizeESRSReport(id) {
    return HttpUtil.patchForReportingService(API_ROUTES.ESRSREPORT.FINALIZE
      .replace('<id>', id));
  }

  static deleteESRSReport(reportId) {
    return HttpUtil.deleteForReportingService(API_ROUTES.ESRSREPORT.DELETE_REPORT.replace('<id>', reportId));
  }

  static createJobAndUpdateESRSReport(payload) {
    return HttpUtil.postForReportingService(API_ROUTES.ESRSREPORT.CREATE_JOB_UPDATE_REPORT, payload);
  }

  static updateESRSReportContent(payload) {
    return HttpUtil.postForReportingService(API_ROUTES.ESRSREPORT.UPDATE_REPORT_CONTENT, payload);
  }

  static failedESRSReport(id) {
    return HttpUtil.patchForReportingService(API_ROUTES.ESRSREPORT.FAILED
      .replace('<id>', id));
  }

  static getReportSettings() {
    return HttpUtil.getFromReportingService(API_ROUTES.REPORT.GET_SETTINGS);
  }

  static updateReportSettings(settings) {
    return HttpUtil.postForReportingService(API_ROUTES.REPORT.SAVE_SETTINGS, settings);
  }

  static listVSMEReports(
    pageNumber = 0,
    pageSize = 10,
    regulationId = "",
    companyId = "",
    status = '',
    type = '',
    year = ''
  ) {
    return HttpUtil.getFromReportingService(
      API_ROUTES.VSME_REPORT.LIST_REPORTS
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(regulationId ? "<regulationId>" : "&regulationId=<regulationId>", regulationId)
        .replace(companyId ? "<companyId>" : "&companyId=<companyId>", companyId)
        .replace(status >= 0 ? "<status>" : "&status=<status>", status >= 0 ? status : '')
        .replace(type ? "<type>" : "&type=<type>", type)
        .replace(year ? "<year>" : "&year=<year>", year)
    );
  }

  static listGHGReports(
    pageNumber = 0,
    pageSize = 10,
    regulationId = "",
    companyId = "",
    status = '',
    type = '',
    year = ''
  ) {
    return HttpUtil.getFromReportingService(
      API_ROUTES.GHGREPORT.LIST_GHG_REPORTS
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(regulationId ? "<regulationId>" : "&regulationId=<regulationId>", regulationId)
        .replace(companyId ? "<companyId>" : "&companyId=<companyId>", companyId)
        .replace(status >= 0 ? "<status>" : "&status=<status>", status >= 0 ? status : '')
        .replace(type ? "<type>" : "&type=<type>", type)
        .replace(year ? "<year>" : "&year=<year>", year)
    );
  }

  static getBRSRReportTemplateBasic({ pageId, type, standardId, periodStart, periodEnd, rFreq, offset }) {
    return HttpUtil.get(API_ROUTES.BRSRREPORT.GET_TEMPLATE_BASIC
      .replace('<pageId>', pageId ?? '')
      .replace('<type>', type ?? '')
      .replace('<standardId>', standardId ?? '')
      .replace('<periodStart>', periodStart ?? '')
      .replace('<periodEnd>', periodEnd ?? '')
      .replace('<rFreq>', rFreq ?? '')
      .replace('<offset>', offset !== undefined && offset !== null ? offset.toString() : '')
    );
  }

  static updateReportPage(reportId, pageId, payload) {
    return HttpUtil.putForReportingService(
      API_ROUTES.REPORT.UPDATE_REPORT_PAGE
        .replace("<reportId>", reportId)
        .replace("<pageId>", pageId),
      payload
    );
  }

  static createReportSection(reportId, payload) {
    return HttpUtil.postForReportingService(
      API_ROUTES.REPORT.CREATE_REPORT_SECTION.replace("<reportId>", reportId),
      payload
    );
  }

  static updateReportSection(reportId, sectionId, payload) {
    return HttpUtil.putForReportingService(
      API_ROUTES.REPORT.UPDATE_REPORT_SECTION
        .replace("<reportId>", reportId)
        .replace("<sectionId>", sectionId),
      payload
    );
  }

  static deleteReportSection(reportId, sectionId) {
    return HttpUtil.deleteForReportingService(
      API_ROUTES.REPORT.DELETE_REPORT_SECTION
        .replace("<reportId>", reportId)
        .replace("<sectionId>", sectionId)
    );
  }

  static createReportPage(reportId, sectionId, payload) {
    return HttpUtil.postForReportingService(
      API_ROUTES.REPORT.CREATE_REPORT_PAGE
        .replace("<reportId>", reportId)
        .replace("<sectionId>", sectionId),
      payload
    );
  }

  static deleteReportPage(reportId, sectionId, pageId) {
    return HttpUtil.deleteForReportingService(
      API_ROUTES.REPORT.DELETE_REPORT_PAGE
        .replace("<reportId>", reportId)
        .replace("<sectionId>", sectionId)
        .replace("<pageId>", pageId)
    );
  }
}
